// Sanitizes a string for a filename (very conservative)
const INVALID_FILENAME_CHARS_REGEXP = /[;',:\\/?*"|<>]/g;
const WHITESPACE_REGEXP = /\s/;
const RESERVED_FILE_NAMES = new Set([".", ".."]);
// 255 is a common filename limit on Linux filesystems.
const MAX_FILENAME_LENGTH = 255;

/** Sanitizes a string for a filename */
export function sanitizeFilenameBase(s: string) {
  const trimmed = (s ?? "").trim();
  const noBadChars = trimmed.replace(INVALID_FILENAME_CHARS_REGEXP, "-");
  // Collapse whitespace and replace with underscores
  const sanitizedString = noBadChars.replace(/\s+/g, "_").replace(/_+/g, "_").replace(/\.+$/g, "");

  if (!sanitizedString || RESERVED_FILE_NAMES.has(sanitizedString)) {
    return "";
  }

  return sanitizedString.length > MAX_FILENAME_LENGTH ? sanitizedString.slice(0, MAX_FILENAME_LENGTH) : sanitizedString;
}

export function fileNameFieldValidation(value?: string) {
  if (value == null) {
    return undefined;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return "The name cannot be empty.";
  }
  if (RESERVED_FILE_NAMES.has(trimmed)) {
    return "The name cannot be '.' or '..'.";
  }
  if (trimmed.endsWith(".")) {
    return "The name cannot end with a dot.";
  }
  if (WHITESPACE_REGEXP.test(value)) {
    return "The name cannot contain whitespace.";
  }

  const forbiddenChars = value.match(INVALID_FILENAME_CHARS_REGEXP);
  if (forbiddenChars?.length) {
    return `The name contains characters that are not allowed: ${forbiddenChars.join("")}`;
  }

  if (value.length > MAX_FILENAME_LENGTH) {
    return `The name must be ${MAX_FILENAME_LENGTH} characters or fewer.`;
  }
  return undefined;
}
